import { render } from "./ViewerMainHeader.vue?vue&type=template&id=dc7b2da8"
import script from "./ViewerMainHeader.vue?vue&type=script&lang=js"
export * from "./ViewerMainHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__